export function phoneNumberInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9()+]/g, '');
}
export function alphaNumericForceUppercaseInputFilter(value) {
    if (!value)
        return '';
    return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
export function abnInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9]/g, '').substr(0, 11);
}
export function prescriberNumberInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9]/g, '').substr(0, 7);
}
export function hpiOInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9]/g, '').substr(0, 16);
}
export function numberInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9]/g, '');
}
export function numberEqualToOneInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^1]/g, '');
}
export function numberGreaterThanZeroInputFilter(value) {
    if (!value)
        return '';
    if (value === '0')
        return '';
    return value.replace(/[^0-9]/g, '');
}
export function decimalNumberInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9.]/g, '');
}
export function numberStringInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9\s]/g, '');
}
export function uppercaseStringInputFilter(value) {
    if (!value)
        return '';
    return value.toUpperCase();
}
export function dateInputFilter(value) {
    if (!value)
        return '';
    // expected value dd/MM/yyyy
    return value.replace(/[^0-9\/]/g, '').substr(0, 10);
}
export function timeInputFilter(value) {
    if (!value)
        return '';
    // expected value HH:mm
    return value.replace(/[^0-9:]/g, '').substr(0, 5);
}
export function emailInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^0-9a-zA-Z\@\.]/g, '');
}
export function alphaNumericInputFilter(value) {
    if (!value)
        return '';
    return value.replace(/[^a-zA-Z0-9\s,!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, '');
}
